import { client } from "api-client";

import { getIsomorphicRequestData } from "src/lib/isomorphicRequestData/getIsomorphicRequestData";

client.setConfig({
  baseUrl: import.meta.env.VITE_APP_API_BASE_URL,
  credentials: "include",
});

client.interceptors.request.use((request) => {
  if (request.headers.has("Cookie")) {
    return request;
  }

  const { cookieHeader } = getIsomorphicRequestData();

  if (cookieHeader) {
    request.headers.set("Cookie", cookieHeader);
  }

  return request;
});
